import i18n from '@/i18n';
import loadable from '@loadable/component';

export default (children?: any) => [
  {
    needLogin: true,
    menuRoot: true,
    resourceName: i18n.t('main-index-1992f2b807d31da10-1'),
    routerUrl: '/main',
    type: '2',
    resourceIcon: '',
    buttons: [],
    component: loadable(() => import('./Layout')),
    children,
  },
];
